/*
 * Liive: keep variant-driven blocks (feature tiles, specifications) in step
 * with the selected variant.
 *
 * On a product page the variant picker only morphs itself, then dispatches
 * `variant:update` (bubbling) with the freshly rendered page in
 * event.detail.data.html. Any element marked [data-liive-variant-refresh]
 * takes its contents and `hidden` state from the element with the same id in
 * that response. Events from other products (cards, quick add) are ignored by
 * product id. After a swap it dispatches liive:variant-refreshed (bubbling,
 * detail.element) so assets/liive-dims.js can re-measure the new photo.
 * When the whole <main> is morphed (combined listings) the blocks
 * are already fresh and nothing here is needed.
 */
if (!window.__liiveVariantRefresh) {
  window.__liiveVariantRefresh = true;

  document.addEventListener('variant:update', (event) => {
    const detail = /** @type {any} */ (event).detail;
    const html = detail?.data?.html;
    if (!html || typeof html.getElementById !== 'function') return;

    const productId = detail?.data?.productId ? String(detail.data.productId) : '';

    document.querySelectorAll('[data-liive-variant-refresh]').forEach((element) => {
      if (!(element instanceof HTMLElement) || !element.id) return;
      if (productId && element.dataset.productId && element.dataset.productId !== productId) return;

      const fresh = html.getElementById(element.id);
      if (!fresh) return;

      element.innerHTML = fresh.innerHTML;
      element.hidden = fresh.hasAttribute('hidden');
      for (const attr of Array.from(fresh.attributes)) {
        if (attr.name.startsWith('data-liive-') && attr.name !== 'data-liive-variant-refresh') {
          element.setAttribute(attr.name, attr.value);
        }
      }
      element.dispatchEvent(new CustomEvent('liive:variant-refreshed', { bubbles: true, detail: { element } }));
    });
  });
}
